import '../../assets/index.less'

const AgreementUserinfo = () => {
  document.title = '用户信息采集须知'
  return (
    <div className="page agreement">
      <div className="main">
        <img className="logo" src={require('../../assets/logo.png')} alt="" />
        <div className="h1">用户信息采集须知</div>
        {/* <div className="p">版本更新日期：2022年6月20日</div>
        <div className="p">版本生效日期：2022年6月20日</div> */}
        <div style={{ height: '10px' }}></div>
        <div className="p">
          评测考证服务由上海商汤数字科技有限公司提供，本服务将收集包括您的姓名、身份号、证件照在内的个人信息，商汤数科承诺您的信息将仅被用于评测考级过程中的实名认证、电子证书发放之目的，并仅在您使用元萝卜AI下棋机器人服务期间保存。若您是不满18周岁的未成年人，提供上述信息前请您务必取得监护人同意，并在监护人的协助下使用本服务。
        </div>
      </div>
    </div>
  )
}

export default AgreementUserinfo
